import axios from 'axios';

export const HTTP = axios.create({
    //baseURL: `http://10.10.10.8:81`
    //baseURL: `http://52.138.27.250/`
    //baseURL: `https://citizenportal-admin-test-qa.esolg.ca`
    //baseURL: `https://citizenportal-api.stg.esolg.ca`
    baseURL: window.BASEURL
})

